import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
  totalPage,
  data,
  pageChangeHandler,
  usersPerPage,
  currentPage,
  searchValue,
  searchedDataPageCounts,
}) => {
  const pageCount = Math.ceil(data?.length / usersPerPage);
  const searchedPageCounts = Math.ceil(
    searchedDataPageCounts?.length / usersPerPage
  );
  return (
    <div
      className="row mt-4"
    // style={{
    //   position: "absolute",
    //   bottom: "20px",
    //   right: "25px",
    // }}
    >
      <div className="col-lg-12">
        <ReactPaginate
          previousLabel={currentPage !== 1 ? "Previous" : null}
          nextLabel={currentPage != totalPage && "Next"}
          pageCount={totalPage}
          onPageChange={(page) => pageChangeHandler(page.selected)}
          containerClassName={"paginationBttns"}
          previousLinkClassName={currentPage !== 1 ? "Previous" : "hideBtn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
          forcePage={currentPage - 1}
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default Pagination;
